import { useTranslation } from 'react-i18next';
import classes from './Photos.module.scss';
import image_01 from '../../../assets/img/Gallery/Photos/image_01.avif';
import image_02 from '../../../assets/img/Gallery/Photos/image_02.avif';
import image_03 from '../../../assets/img/Gallery/Photos/image_03.avif';
import image_04 from '../../../assets/img/Gallery/Photos/image_04.avif';
import image_05 from '../../../assets/img/Gallery/Photos/image_05.avif';
import { useEffect, useRef } from 'react';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

const images = [
    {
        img: image_01,
        class: 'image grid-item size-1',
    },
    {
        img: image_02,
        class: 'image grid-item size-2 image-2',
    },
    {
        img: image_03,
        class: 'image grid-item size-2',
    },
    {
        img: image_04,
        class: 'image grid-item size-1',
    },
    {
        img: image_05,
        class: 'image grid-item size-3',
    },
];

const Photos = () => {
    const { t } = useTranslation();
    const gridRef = useRef(null);

    useEffect(() => {
        const grid = gridRef.current;

        const msnry = new Masonry(grid, {
            itemSelector: ".grid-item",
            columnWidth: ".grid-sizer",
            percentPosition: true,
            // gutter: 20,
        });

        imagesLoaded(grid, () => msnry.layout());
    }, []);

    return (
        <section className="mt container">
            <div className={classes.wrap}>
                <div className={classes.grid} ref={gridRef}>
                    <div className="grid-sizer"></div>

                    {images.map((item, index) =>
                        <div
                            key={index}
                            className={item.class}
                        >
                            <img src={item.img} alt="" />
                        </div>
                    )}
                </div>

                <div className={classes.mob}>
                    {images.map((item, index) =>
                        <img className={classes.image} key={index} src={item.img} alt="" />
                    )}
                </div>
            </div>
        </section>
    );
};

export default Photos;
